import { Physician } from '~/interfaces'

export enum ELaboratoryTestNotePropertySubtypes {
  ANTIBIOGRAM_METHOD = 'metodo_antibiograma',
  RESULT_TEXT = 'texto_resultado',
  NONE = ''
}

export enum ELaboratoryTestQualitativePropertySubtypes {
  ANTIBIOTIC_RESISTANCE = 'resistencia_antibiotico',
  ORGANISM_GROWTH = 'crescimento_organismo',
  NONE = ''
}

export enum ELaboratoryTestPropertyTypes {
  NOTE = 'nota',
  QUALITATIVE = 'qualitativa',
  QUANTITATIVE = 'quantitativa',
  SECTION = 'secao',
  COMMENT = 'comentario'
}

export interface IFetchLaboratoryTestsParams {
  pathParams: {
    patientId: number
  }
  queryParams?: {
    description?: string
    startDate?: string
    endDate?: string
    testCodes?: number[]
  }
}

export interface IFetchLaboratoryTestParamsById {
  testId: string
}

export interface ILaboratoryTest {
  id: string
  code: string
  startDate: string
  endDate: string
  passage: string
  type: string
  description: string
  patientId: number
  responsiblePhysician: Physician
  referringPhysician: Physician
}

export interface LaboratoryTestNoteProperty {
  code: number
  date: string
  type: ELaboratoryTestPropertyTypes.NOTE
  sample: string
  title: string
  sampleCollectionMethod: string
  subtype: ELaboratoryTestNotePropertySubtypes
  description: string
  complement?: string
  testId?: number
}

export interface LaboratoryTestQualitativeProperty {
  code: number
  type: ELaboratoryTestPropertyTypes.QUALITATIVE
  date: string
  sample: string
  name: string
  value: string
  sampleCollectionMethod: string
  subtype: ELaboratoryTestQualitativePropertySubtypes
  referenceValue?: string
  interpretation?: string
  complement?: string
  testId: number
}

export interface LaboratoryTestQuantitativeProperty {
  code: number
  type: ELaboratoryTestPropertyTypes.QUANTITATIVE
  date: string
  sample: string
  name: string
  prefix?: string
  value: number
  unit?: string
  sampleCollectionMethod: string
  subtype: string
  lowerReferenceValue?: number
  upperReferenceValue?: number
  interpretation?: string
  complement?: string
  testId?: number
}

export interface LaboratoryTestSectionProperty {
  code: number
  type: ELaboratoryTestPropertyTypes.SECTION
  date: string
  sample: string
  title: string
  sampleCollectionMethod: string
  subtype: string
}

export interface LaboratoryTestCommentProperty {
  code: number
  type: ELaboratoryTestPropertyTypes.COMMENT
  date: string
  sample: string
  sampleCollectionMethod: string
  description: string
  testId?: number
}

export type ILaboratoryTestProperty =
  | LaboratoryTestNoteProperty
  | LaboratoryTestQualitativeProperty
  | LaboratoryTestQuantitativeProperty
  | LaboratoryTestSectionProperty
  | LaboratoryTestCommentProperty

export interface IFetchLaboratoryTestPropertiesParams {
  pathParams: {
    testId: string
  }
}

export type PropertyMeasurementSubType = 'resistencia_antibiotico' | 'crescimento_organismo'

export interface IFetchPropertyMeasurementHistoryParams {
  pathParams: {
    patientId: number
  }
  queryParams?: {
    propertyCodes?: number[]
    sample?: string
    type?: ELaboratoryTestPropertyTypes
    testCodes?: number[]
    subtype?: PropertyMeasurementSubType
    startDate?: string
    endDate?: string
  }
}
